import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

export const DeleteModal = (userID) => {
    const user = useSelector(state => state.user);
    const [widthIsBigger, setWidthIsBigger] = useState(false);
    useEffect(() => {
        if (!R.isNil(user.profilePicture)) {
            let i = new Image();
            i.onload = function () {
                setWidthIsBigger(i.width > i.height);
            };
            i.src = user.profilePicture;
        }
    }, [user.profilePicture]);

    return (
    <div className="modal fade px-0" id="deleteCompte" aria-labelledby="deleteCompteLabel" aria-hidden="true">
        <div className="modal-dialog px-2">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="alert bg-alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                        <h1 className="sr-only visually-hidden">Supprimer</h1>
                        <div className="flex-row align-items-center justify-content-between">
                            <div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="deleteCompteLabel">Supprimer compte</div>
                            <button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
                                <i className="eva eva-close fs-4"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="modal-body text-center">
                    <div className={"d-flex mx-auto h-avatar w-avatar rounded-circle font-weight-bold mb-2" + (R.isNil(user.profilePicture) ? ' bg-dim' : '')}>
                        {!R.isNil(user.profilePicture) ?
                            <img className={"img-fluid h-100 w-100 rounded-inherit" + (widthIsBigger ? ' img-contain bg-white border' : ' img-cover')} alt="avatar" src={user.profilePicture} />
                            :
                            <i className="eva eva-image-2 h2 lh-1 m-auto icon-default"></i>
                        }
                    </div>
                    <div className="fs-sm ls-n1">Etes-vous sûr(e) de vouloir supprimer la compte <strong>"{R.isNil(user) ? '' : user.user.firstName} {R.isNil(user) ? '' : user.user.lastName}"</strong>?</div>
                    <div className="fs-3 o-60">Cette action est irréversible.</div>
                </div>
                <div className="modal-footer justify-content-center">
                        <button type="button" className="btn btn-faded" data-dismiss="modal" aria-label="Close">Annuler</button>
                        <button type="button" className="btn btn-danger" >Supprimer</button>
                </div>
            </div>
        </div>
    </div>
    );
}